import { render, staticRenderFns } from "./SuperUserLogin.vue?vue&type=template&id=85f855ea&scoped=true&"
import script from "./SuperUserLogin.vue?vue&type=script&lang=js&"
export * from "./SuperUserLogin.vue?vue&type=script&lang=js&"
import style0 from "./SuperUserLogin.vue?vue&type=style&index=0&id=85f855ea&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f855ea",
  null
  
)

export default component.exports